import Pageheader from 'components/Pageheader';
import ModalContext from 'contexts/ModalContext';
import ModalVerified from 'components/modal/ModalVerified';
import React, { useEffect, useState, useContext, useRef } from 'react'
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import { PostRequestOTP, PostVerifyOTP } from 'services/Api/Module/Otp';
import useBookingPage from 'services/store/BookingPage';
import { CreateCustomer } from 'services/Api/Module/Customer';
import useProfileStore from 'services/store/ProfileModule';
import { data } from 'jquery';
import CountdownTimer from 'components/CountdownTimer';
import moment from 'moment';
import useTranslations from 'i18n/useTranslations';

const defOtpExpire = moment().toISOString();

const PopupOtp = ({
    mobile = '',
    onBack = () => console.log('onBack!'),
    onSave = () => console.log('onSave!')
}) => {
    const { t } = useTranslations();
    const navigate = useNavigate();
    const { mAlert } = useContext(ModalContext);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const { register } = useBookingPage();
    const lineProfile = useProfileStore();
    const [statusCode, setStatusCode] = useState(20000);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    // OTP
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [otpExpire, setOtpExpire] = useState(defOtpExpire);
    const [verifyCode, setVerifyCode] = useState("");
    const hiddenInputRef = useRef(null);

    const handleOnClick = () => {
        onBack()
    }
    const handleOpen = () => {
        const otpValue = otp.join('');
        let payload = {
            code: otpValue,
            sessionId: verifyCode
        };
        fetchPostVerifyOTP(payload);
    }
    const handleOk = () => {
        setIsButtonDisabled(true);
    }

    const handleInput = (e, index) => {
        const input = e.target.value;
        if (/^\d*$/.test(input)) { // ตรวจสอบว่าเป็นตัวเลขหรือไม่
            const newOtp = [...otp];
            newOtp[index] = input;
            setOtp(newOtp);

            if (input && index < otp.length - 1) {
                document.getElementById(`otp-${index + 1}`).focus();
            }
        }
    };


    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && otp[index] === "") {
            if (index > 0) {
                document.getElementById(`otp-${index - 1}`).focus();
                e.preventDefault(); // ป้องกันการลบข้อมูลในช่องก่อนหน้า
            }
        }
    };

    const handleResend = () => {
        const payload = { mobile: mobile }
        fetchPostRequestOTP(payload);
    }
    const handlePaste = (e) => {
        const paste = e.clipboardData.getData('text');
        if (/^\d*$/.test(paste) && paste.length === otp.length) {
            const newOtp = paste.split("");
            setOtp(newOtp);

            newOtp.forEach((digit, index) => {
                document.getElementById(`otp-${index}`).value = digit;
            });

            handleOpen();
        }
    };

    const fetchPostRequestOTP = async (payload) => {
        try {
            const response = await PostRequestOTP({ data: payload });
            const resData = response?.data;
            if (resData?.resultCode == "20000") {
                setVerifyCode(resData?.resultData?.sessionId);
                const expiresAt = moment(resData?.resultData?.expiresAt);
                expiresAt.add(-7, 'hours');
                setOtpExpire(expiresAt.toISOString());
            } else if (resData?.resultCode == "40501") {
                mAlert.info({
                    title: t.register.popup.notification,
                    subTitle: t.SYSTEM.OTP.C40501,
                    content: "",
                    onClose: () => { },
                });
            } else if (resData?.resultCode == "40505") {
                mAlert.info({
                    title: t.register.popup.notification,
                    subTitle: t.SYSTEM.OTP.C40505,
                    content: "",
                    onClose: () => { },
                });
            } else {
                mAlert.info({
                    title: "ไม่พบเบอร์มือถือ",
                    subTitle: "เบอร์มือถือนี้ไม่ตรงกับเบอร์ในระบบ",
                    content: "",
                    onClose: () => { },
                });
            }
        } catch (err) {
            console.log('err ', err);
            mAlert.info({
                title: t.register.popup.notification,
                subTitle: t.register.popup.wrong,
                content: "",
                onClose: () => { },
            });
        }
    };
    const fetchPostVerifyOTP = async (payload) => {
        try {
            const response = await PostVerifyOTP({ data: payload });
            const resData = response?.data;
            if (resData?.resultCode == "20000") {
                // setIsOpenModal(true);
                onSave()
            } else if (resData?.resultCode == "40502") {
                mAlert.info({
                    title: t.register.popup.notification,
                    subTitle: t.SYSTEM.OTP.C40502,
                    content: "",
                    onClose: () => { },
                });
            } else if (resData?.resultCode == "40503") {
                mAlert.info({
                    title: t.register.popup.notification,
                    subTitle: t.SYSTEM.OTP.C40503,
                    content: "",
                    onClose: () => { },
                });
            } else if (resData?.resultCode == "40504") {
                mAlert.info({
                    title: t.register.popup.notification,
                    subTitle: t.SYSTEM.OTP.C40504,
                    content: "",
                    onClose: () => { },
                });
            } else {
                mAlert.info({
                    title: t.register.popup.notification,
                    subTitle: t.register.popup.wrong,
                    content: "",
                    onClose: () => { },
                });
            }
        } catch (err) {
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };


    useEffect(() => {
        handleResend();

        if ('OTPCredential' in window) {
            navigator.credentials.get({ otp: { transport: ['sms'] } }).then(otp => {
                const otpValue = otp.code;
                const newOtp = otpValue.split("");

                newOtp.forEach((digit, index) => {
                    document.getElementById(`otp-${index}`).value = digit;
                });

                setOtp(newOtp);
                handleOpen();
            }).catch(err => {
                console.log('Auto-fill OTP error: ', err);
            });
        }

        document.addEventListener('paste', handlePaste);

        return () => {
            document.removeEventListener('paste', handlePaste);
        };
    }, []);

    console.log('profile >>', register.contactNumber)
    return (
        <div>
            <Helmet>
                <title>IMPACT Family</title>
                <meta name="title" content="Impact Family" />
                <meta name="description" content="Impact Family" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="Impact Family" />
                <meta property="og:description" content="Impact Family" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Impact Family" />
            </Helmet>
            <div id="pageOtp">

                <Pageheader pagename={t.verify.verify} onClick={handleOnClick} />

                <main id="top">
                    <div className="wrapContent">
                        <section id="pOtp">
                            <div className="bOtpMain">
                                <div className="bOtp">
                                    <div className="bText">
                                        <div className="bPic">
                                            <img src="assets/img/ui/form/ico-otp.svg" alt="" />
                                        </div>
                                        <h3>{t.verify.code}</h3>
                                        <p>
                                            {t.verify.otpMessage}
                                            <span>{t.verify.toPhone} {register?.contactNumber}</span>
                                        </p>
                                    </div>
                                    <div className={`bFrom ${statusCode === 20000 ? null : 'error'}`}>
                                        <div className="control-group otp">
                                            {otp.map((digit, index) => (
                                                <input
                                                    key={index}
                                                    id={`otp-${index}`}
                                                    className="smsCode"
                                                    inputMode="numeric"
                                                    type="text"
                                                    maxLength="1"
                                                    size="1"
                                                    min="0"
                                                    max="9"
                                                    pattern="[0-9]{1}"
                                                    value={digit}
                                                    onInput={(e) => handleInput(e, index)}
                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                />
                                            ))}
                                            <input
                                                ref={hiddenInputRef}
                                                type="text"
                                                inputMode="numeric"
                                                style={{ position: 'absolute', left: '-9999px' }}
                                                onPaste={handlePaste}
                                            />
                                        </div>
                                        {statusCode !== 20000 && (
                                            <label htmlFor="" className="tError">{t.verify.fail}</label>
                                        )}

                                        <div className="bTextCount">
                                            <div className="bCountTime">
                                                {t.verify.expired} <span id="timer"><CountdownTimer expireDateTime={otpExpire} onExpire={() => console.log("OTP expire")} /></span> {t.verify.mins}
                                            </div>
                                            <div className="bTextSend">
                                                <p>{t.verify.tryAgain} <a onClick={handleResend}>{t.verify.resend}</a></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bBtn">
                                        <button className="btn" id="btnModalVerifiedComplete" onClick={handleOpen} disabled={otp.join('').length !== 6 || isButtonDisabled }>{t.verify.confirm}</button>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </main>
                <ModalVerified onClick={handleOk} open={isOpenModal} isButtonDisabled={isButtonDisabled} mode="edit-profile"/>
                {/* <!-- Modal -->
                <?php $pathcomplete = "register-complete.php";  include 'inc/inc-modal.php';?> */}

            </div>
        </div>
    )
}

export default PopupOtp